/**
 * App Feedback & Suggestions' live site (FEEDBACK-PLAN.md #677). Every site, staging and test
 * included, saves reports to the one store, so every app links here, never to a copy of its own.
 */
export const APP_FEEDBACK_URL = 'https://feedback.higgins.com.au';

/** App Feedback's My reports page, where a user follows what happened to their reports. */
export const MY_REPORTS_URL = `${APP_FEEDBACK_URL}/mine`;

/** The query string App Feedback's report page reads (`/report`). */
export const REPORT_PAGE_PARAMS = { app: 'app', page: 'page', version: 'v', commit: 'c', branch: 'b' } as const;

/**
 * App Feedback's report page for an app with no API of its own (Estimate to Jobpac, Power BI
 * Help): the app's key, the page the user was on and the app's build go in the address. None is
 * personal; the user is the one signed in to App Feedback.
 */
export function reportPageUrl(appKey: string, page: string, build: { version?: string; commit?: string; branch?: string }): string {
  const query = new URLSearchParams({ [REPORT_PAGE_PARAMS.app]: appKey, [REPORT_PAGE_PARAMS.page]: page });
  if (build.version) query.set(REPORT_PAGE_PARAMS.version, build.version);
  if (build.commit) query.set(REPORT_PAGE_PARAMS.commit, build.commit);
  if (build.branch) query.set(REPORT_PAGE_PARAMS.branch, build.branch);
  return `${APP_FEEDBACK_URL}/report?${query}`;
}

/** What App Feedback's report page reads back from its address (the inverse of reportPageUrl). */
export function readReportPageUrl(search: URLSearchParams): { appKey: string; path: string; build: { version?: string; commit?: string; branch?: string } } {
  const value = (name: string) => search.get(name) || undefined;
  return {
    appKey: search.get(REPORT_PAGE_PARAMS.app) ?? '',
    path: search.get(REPORT_PAGE_PARAMS.page) || '/',
    build: { version: value(REPORT_PAGE_PARAMS.version), commit: value(REPORT_PAGE_PARAMS.commit), branch: value(REPORT_PAGE_PARAMS.branch) },
  };
}
